export enum TableType {
    Subdivisions,
    Lots,
    BuildingDepartments
}